import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { UseMutationOptions } from 'react-query/types/react/types'

interface Variables {
  id: number
}

export type Options = Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'>

export const deleteSchedule = async (id: number) => {
  const result = await sendToApi<void>(`/schedules/${id}`, { method: 'DELETE' })

  if (result.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error()
  }

  return result.data
}

export const useDeleteSchedule = (options?: Options) => {
  return useMutation<void, Error, Variables>((vars) => deleteSchedule(vars.id), options)
}
